import { useTranslate } from 'ra-core'

const BrandTitle = ({ record }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Brand Registry')} - {record && record.name ? `"${record.name}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./Brands'), component: 'BrandList' },
  create: { lazy: () => import('./Brands'), component: 'BrandCreate' },
  edit: { lazy: () => import('./Brands'), component: 'BrandEdit' },
  options: {
    create: {
      title: 'Brand Registry',
      subtitle: null,
      breadCrumb: 'Register Brand',
    },
    list: {
      title: 'Brand Registry',
      subtitle: null,
      breadCrumb: 'Brand Registry',
    },
    edit: {
      title: <BrandTitle />,
      subtitle: null,
      breadCrumb: 'Edit Brand',
    },
  },
}
